var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmap-polyline',{attrs:{"path":_vm.points,"options":{
    strokeColor: _vm.strokeColor,
    ..._vm.dashOptions,
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }